<template>
    <div class="cz2__group-ordering-bottle-details">
        <header class="cz2__group-ordering-bottle-header">
            <div class="cz2__group-ordering-bottle-title cz2__type__small">{{$t('GROUP_BOTTLE_LABEL', {bottle: bottleIndex + 1})}}</div>
            <button
                v-if="bottleIndex !== 0"
                class="cz2__group-ordering-bottle-remove cz2__type__small"
                @click="removeBottle(bottleIndex)"
            >{{$t('GROUP_REMOVE')}}</button>
        </header>

        <div class="cz2__group-ordering-bottle-lines">
            <!-- Each line for the bottle -->
            <input
                v-for="(line, lineIndex) in lines"
                v-bind:key="lineIndex"
                :value="getLineValue(lineIndex)"
                class="cz2__group-ordering-bottle-line cz2__type__small"
                @input="updateText(bottleIndex, lineIndex, $event.target.value)"
                @blur="updateTextDone"
            />
        </div>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {

        .cz2__group-ordering-bottle-details {
            border: $standard-border;
            background: #fff;
            padding: 20px;
            margin-top: 20px;
        }

        .cz2__group-ordering-bottle-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .cz2__group-ordering-bottle-header {
            margin-bottom: 13px;
            &:last-child {
                margin-bottom: 0;
            }
        }

        .cz2__group-ordering-bottle-remove {
            color: $remove-color;
            text-decoration: underline;
        }

        .cz2__group-ordering-bottle-line {
            display: block;
            border: $input-border;
            padding: 13px 14px;
            width: 100%;
            height: 44px;
            margin-bottom: 10px;
            &:last-child {
                margin-bottom: 0;
            }
        }
    }
</style>

<script>
    export default {
        components: {},
        props: {
            lines: {
                type: Array,
            },
            bottleIndex: {
                type: Number,
            },
        },
        data() {
            return {};
        },
        computed: {},
        mounted() {},
        methods: {
            /**
            * Get the value for the line, depends if it's a primary line or not
            */
            getLineValue(lineIndex) {
                const line = this.lines[lineIndex];
                if (line && line.placement) {
                    // Line is a placement
                    return line.component.custom['personalization-text'];
                }
                // Line is a string
                return line;
            },

            /**
             * Update the text for the primary bottle / text placements
             */
            updateText(bottleIndex, lineIndex, newText) {
                this.$emit('update-text', bottleIndex, lineIndex, newText);
            },

            /**
             * Remove bottle at a specific index
             */
            removeBottle(bottleIndex) {
                this.$emit('remove-bottle', bottleIndex);
            },

            updateTextDone() {
                this.$emit('update-text-done');
            },
        },
    };
</script>
